import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import './assets/custom.scss'
import api from './services/api';
import VueMask from 'v-mask'
import Vuelidate from 'vuelidate'
import VuejsDialog from 'vuejs-dialog';
import VueAppInsights from 'vue-application-insights'

Vue.prototype.$http = api; 
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.use(VuejsDialog);
Vue.use(VueAppInsights, {
  baseName: 'studentPdf', // prefix to track route changes as page views with AppInsights
  id: 'a80be7e2-3d1f-4e60-8558-031114d1cd11',
  router
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
